import { combineReducers } from 'redux'

import campaigns from './campaigns'

export default combineReducers({
  campaigns,
})
